"use strict";

var moduleName = "scroll-to-auth-mobile";

module.exports = function () {
	$(".header-mobile-auth").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		var widthMainWindow	 = window.innerWidth,
			elementScrollTop = ($(this).offset().top);

		if(widthMainWindow <= 750 && $.cookie("entrance") == "true") {
			$(document).scrollTop(elementScrollTop);
		} else {
			$(document).scrollTop((elementScrollTop - 30));

			$.cookie("entrance", "true", {
				expires: 0,
				path: "/"
			});
		}



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/scrollToAuthMobileInit.js
 **/